import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useEffect } from 'react'

export default function DialogPopup({
  isOpen = false,
  children,
  closeModal,
  openModal
}) {
  useEffect(() => {
    if (!isOpen) {
      // Remove overflow hidden and padding-right from html tag when modal closes
      const htmlElement = document.documentElement
      htmlElement.style.overflow = ''
      htmlElement.style.paddingRight = ''
    }
  }, [isOpen])

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="fixed inset-0 z-10 overflow-y-auto"
        onClose={closeModal}
      >
        <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
        <div className="min-h-screen px-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="inline-block h-screen align-middle"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="inline-block md:w-[400px] max-w-md px-20 py-30 mx-10 my-8 overflow-hidden text-center align-middle transition-all transform bg-white text-body shadow-xl rounded-lg ">
              {children}
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  )
}
